import "./About.module.css";
import Navigation from "@/reusable_sections/Header";
import TheStarshipVision from "./sections/TheStarshipVision";
import CorporateMilestones from "./sections/CorporateMilestones";
import GlobalPartners from "./sections/GlobalPartners";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <TheStarshipVision />
      <CorporateMilestones />
      <GlobalPartners />
      <Footer />
    </div>;
}